import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from '@mui/material';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  hasActions?: boolean;
}

export function TableSkeleton({ rows = 5, columns = 4, hasActions = true }: TableSkeletonProps) {
  const columnArray = Array.from({ length: columns }, (_, i) => i);
  const rowArray = Array.from({ length: rows }, (_, i) => i);

  return (
    <TableContainer
      component={Paper}
      elevation={3}
      sx={{
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Table>
        <TableHead>
          <TableRow
            sx={{
              backgroundColor: 'primary.main',
            }}
          >
            {columnArray.map((index) => (
              <TableCell key={`header-${index}`}>
                <Skeleton
                  variant="text"
                  width="80%"
                  height={24}
                  sx={{ bgcolor: 'rgba(255, 255, 255, 0.3)' }}
                />
              </TableCell>
            ))}
            {hasActions && (
              <TableCell sx={{ width: '150px', textAlign: 'center' }}>
                <Skeleton
                  variant="text"
                  width="60%"
                  height={24}
                  sx={{ bgcolor: 'rgba(255, 255, 255, 0.3)', mx: 'auto' }}
                />
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowArray.map((rowIndex) => (
            <TableRow
              key={`row-${rowIndex}`}
              sx={{
                '&:nth-of-type(odd)': {
                  backgroundColor: 'action.hover',
                },
              }}
            >
              {columnArray.map((colIndex) => (
                <TableCell key={`cell-${rowIndex}-${colIndex}`}>
                  <Skeleton
                    variant="text"
                    width={colIndex === 0 ? '60%' : '90%'}
                    height={20}
                  />
                </TableCell>
              ))}
              {hasActions && (
                <TableCell>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      justifyContent: 'center',
                    }}
                  >
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                  </Box>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
